import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { Box, TextField, Typography } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { useForm, Controller } from 'react-hook-form'

import { BaseDialog, LoadingFeedback } from 'components'

import * as service from 'service'
import schema from './schema'
import theme from 'theme'

import useFetch from 'hooks/useFetch'
import useSnackbar from 'hooks/useSnackbar'

const AddSubCategoryDialog = ({ open, onClose, onSuccess, categoryId }) => {
  const [loading, setLoading] = useState(false)
  const { control, handleSubmit, reset, errors } = useForm({
    validationSchema: schema,
    defaultValues: {
      name: '',
      responsiblesIds: [],
    },
  })

  const { response: usersResponse, isLoading: loadingUsers } = useFetch(
    service.dponet.users.get,
    { perPage: 1000, minimal: true },
    [open],
    open,
  )
  const snackbar = useSnackbar()

  const users = usersResponse?.data?.users || []

  const handleSave = async (data) => {
    setLoading(true)
    try {
      await service.dponet.complaintSubCategories.create({
        categoryId,
        complaintSubCategory: {
          name: data.name.trim(),
          responsiblesIds: data.responsiblesIds.map((user) => user.id),
        },
      })
      snackbar.open({
        message: 'Opção criada com sucesso!',
        variant: 'success',
      })
      handleClose()
      if (onSuccess) onSuccess()
    } catch (error) {
      console.error('Erro ao criar opção:', error)
      snackbar.open({
        message: 'Erro ao criar opção',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  const handleClose = () => {
    onClose()
    reset()
  }

  return (
    <BaseDialog
      dialogSize="md"
      fullWidth
      open={open}
      setOpen={handleClose}
      title="Nova Opção"
      actionButton={handleSubmit(handleSave)}
      actionButtonText="Adicionar"
      closeButtonText="Cancelar"
      disableButton={loading || loadingUsers}
      loading={loading || loadingUsers}
    >
      <LoadingFeedback open={loading || loadingUsers} />
      <Box pt={1} pb={2}>
        <Controller
          name="name"
          control={control}
          as={
            <TextField
              fullWidth
              label="Nome da Opção"
              variant="outlined"
              required
              error={!!errors.name}
              helperText={errors?.name?.message}
            />
          }
        />
      </Box>
      <Box pb={1}>
        <Controller
          name="responsiblesIds"
          control={control}
          onChange={([, data]) => data}
          as={
            <Autocomplete
              multiple
              fullWidth
              loading={loadingUsers}
              options={users}
              getOptionLabel={(option) => option.name || ''}
              getOptionSelected={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Responsáveis"
                  variant="outlined"
                  placeholder="Selecione os responsáveis"
                />
              )}
            />
          }
        />
      </Box>
      <Box
        p={2}
        bgcolor={theme.palette.custom.light}
        borderRadius={1}
        display="flex"
        flexDirection="column"
        gridGap={theme.spacing(1.5)}
      >
        <Typography color="primary" variant="h6">
          Informação
        </Typography>
        <Typography align="justify">
          Selecione os responsáveis pela gestão dessa opção de categoria.
        </Typography>
      </Box>
    </BaseDialog>
  )
}

AddSubCategoryDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  categoryId: PropTypes.number.isRequired,
}

export default AddSubCategoryDialog
